import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { templateService } from '../../services/templateService'
import { GET_REQUEST_TEMPLATE_BY_REQUEST_ID, GET_REQUEST_TEMPLATE_DATA } from '../config'
import { IRequestTemplateActionParams, IRequestTemplateByRequestIdActionParams } from '../models'
import { selectRequestTemplateLoadingStatus } from '../selectors/selectRequestTemplateData'

import { handleApiResponse } from './helpers/handleApiResponse'

class TemplateApi {
  public getRequestTemplate = createAsyncThunk(
    GET_REQUEST_TEMPLATE_DATA,
    async ({ templateUUID }: IRequestTemplateActionParams, _thunkAPI) => {
      const response = await templateService.fetchRequestTemplate(templateUUID)
      return handleApiResponse(response)
    },
    {
      condition({ templateUUID }, { getState }) {
        if (!templateUUID) {
          return false
        }

        const state = getState() as any
        const status = selectRequestTemplateLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getRequestTemplateByRequestId = createAsyncThunk(
    GET_REQUEST_TEMPLATE_BY_REQUEST_ID,
    async ({ requestId }: IRequestTemplateByRequestIdActionParams, _thunkAPI) =>
      await templateService.fetchRequestTemplateByRequestId(requestId),
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectRequestTemplateLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const templateApi = new TemplateApi()
